import { useState, useEffect } from 'react';
import { Box, Typography, Link } from '@mui/material';
import { HomeOutlined } from '@ant-design/icons';
import GlobalBackButton from 'views/utilities/BackButtonGlobal';
import { useLocation } from 'react-router-dom';
const ViewMiddleManager = () => {
    // const [zoneData, setZoneData] = useState({});

    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const stateData = location.state;

    useEffect(() => {
        if (stateData) {
            setLoading(false);
        } else {
            console.error('State data is not available!');
        }
    }, [stateData]);

    // If zoneData is not available, show an error message or fallback UI
    if (!stateData) {
        return (
            <Box sx={{ padding: '20px', backgroundColor: '#fff', borderRadius: 2 }}>
                <Typography variant="h5" color="error">
                    Error: State data is unavailable.
                </Typography>
            </Box>
        );
    }

    return (
        <>
            {/* Header */}
            <Box
                sx={{
                    width: '100%',
                    height: 'auto',
                    backgroundColor: '#fff',
                    borderRadius: 2,
                    mb: 1,
                    padding: '20px 10px',
                    '@media screen and (min-width: 600px)': {
                        padding: 2
                    }
                }}
            >
                <Typography variant="h3">
                    <GlobalBackButton />
                    View Middle Manager
                </Typography>
                <Box sx={{ marginTop: '10px' }}>
                    <Link href="/relation-manager/dashboard" underline="none" color="inherit">
                        <HomeOutlined />
                    </Link>
                    <Typography component="span" style={{ margin: '0 10px' }}>
                        &gt;
                    </Typography>
                    <Typography component="span">View State Head</Typography>
                </Box>
            </Box>

            {/* Loading State */}
            {loading ? (
                <Typography>Loading...</Typography>
            ) : (
                <Box sx={{ padding: '20px', backgroundColor: '#fff', borderRadius: 2 }}>
                    {/* Custom Table */}
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontFamily: 'Arial, sans-serif' }}>
                        <tbody>
                            {/* Name */}
                            <tr>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>Name</td>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}> : {stateData.name || '-'}</td>
                            </tr>

                            {/* Email */}
                            <tr>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>Email</td>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}> : {stateData.email || '-'}</td>
                            </tr>

                            {/* Phone */}
                            <tr>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>Phone</td>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}> : {stateData.phone || '-'}</td>
                            </tr>
                            {/* ZoneHead */}
                            <tr>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>Zone Head</td>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}> : {stateData.zone_head || '-'}</td>
                            </tr>
                            {/*StateHead */}
                            <tr>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>State Head</td>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}> : {stateData.state_head || '-'}</td>
                            </tr>

                            {/* Code */}
                            <tr>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>Code</td>
                                <td style={{ padding: '10px', border: '1px solid #ddd', color: 'red', fontWeight: 'bold' }}>
                                    : {stateData.p1 || '-'}
                                </td>
                            </tr>

                            {/* States */}
                            <tr>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>States</td>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>:{stateData.stateList || '-'}</td>
                            </tr>
                            {/* District */}
                            <tr>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>Districts</td>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>:{stateData.districtList || '-'}</td>
                            </tr>
                            {/* City */}
                            <tr>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>City</td>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>:{stateData.city || '-'}</td>
                            </tr>

                            {/* POA */}
                            <tr>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>POA</td>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                                    <img
                                        src={stateData.poa_file || 'https://via.placeholder.com/50'}
                                        alt="POA"
                                        style={{ width: '50px', height: '50px' }}
                                    />
                                </td>
                            </tr>

                            {/* Photograph */}
                            <tr>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>PHOTOGRAPH</td>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                                    <img src={stateData.image_file} alt="Photograph" style={{ width: '50px', height: '50px' }} />
                                </td>
                            </tr>

                            {/* Status */}
                            <tr>
                                <td style={{ padding: '10px', border: '1px solid #ddd' }}>Status</td>
                                <td
                                    style={{
                                        padding: '10px',
                                        border: '1px solid #ddd',
                                        fontWeight: 'bold',
                                        color: stateData.status === 'ACTIVE' ? 'green' : 'red'
                                    }}
                                >
                                    : {stateData.status || '-'}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Box>
            )}
        </>
    );
};

export default ViewMiddleManager;
